import React from 'react'
import { Stack, Grid, Box, Divider, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import Input from 'components/generic/form/Input'
import Select from 'components/generic/form/Select'

const CarrierGeneralInfoForm = ({ driversOptionList, control, errors }) => {
  return (
    <Stack flexGrow={1} sx={{ pl: 3, pr: 4 }}>
      <Box>
        <Typography variant="h6" color="textSecondary">
          General Information
        </Typography>
        <Box py={1}>
          <Divider />
        </Box>
        <Grid container mt={1} spacing={1}>
          <Grid item md={12} xs={12}>
            <Input
              name="companyName"
              label="Full Name"
              defaultValue=""
              control={control}
              error={!!errors.companyName}
              helperText={errors.companyName?.message}
            />
          </Grid>
          <Grid item md={12} xs={12}>
            <Input
              name="notes"
              label="Notes"
              defaultValue=""
              control={control}
              error={!!errors.notes}
              helperText={errors.notes?.message}
            />
          </Grid>
          <Grid item md={12} xs={12}>
            <Select
              label={'Linked Drivers'}
              disabled={false}
              name={'driverIds'}
              control={control}
              items={driversOptionList}
              selectProps={{ multiple: true, sx: { width: '400px' } }}
              useChips
            />
          </Grid>
        </Grid>
      </Box>
    </Stack>
  )
}

CarrierGeneralInfoForm.propTypes = {
  driversOptionList: PropTypes.array,
  control: PropTypes.object,
  errors: PropTypes.object,
}

CarrierGeneralInfoForm.defaultProps = {
  driversOptionList: [],
  control: {},
  errors: {},
}

export default CarrierGeneralInfoForm
